module.exports = __webpack_public_path__ + "img/index_map_place01.32a89fcf.jpg";